import { useQuery } from '@tanstack/react-query';
import { getSiteConfig, getBrands, getSubsidiaries, getNewsletters, getNewsletter, getNewsletterTypes } from '../api';
import type { ISiteConfig, IBrand, ISubsidiary, INewsletter, PaginatedResponse } from '../types';

export function useSiteConfig() {
  return useQuery<ISiteConfig>({ queryKey: ['siteConfig'], queryFn: getSiteConfig });
}

export function useBrands() {
  return useQuery<IBrand[]>({ queryKey: ['brands'], queryFn: getBrands });
}

export function useSubsidiaries() {
  return useQuery<ISubsidiary[]>({ queryKey: ['subsidiaries'], queryFn: getSubsidiaries });
}

export function useNewsletters(params?: { page?: number; limit?: number; type?: string; customType?: string; featured?: boolean }) {
  return useQuery<PaginatedResponse<INewsletter>>({
    queryKey: ['newsletters', params],
    queryFn: () => getNewsletters(params),
  });
}

export function useNewsletter(slug: string) {
  return useQuery<INewsletter>({
    queryKey: ['newsletter', slug],
    queryFn: () => getNewsletter(slug),
    enabled: !!slug,
  });
}

export function useNewsletterTypes() {
  return useQuery<Array<{ _id: string; customType?: string; count: number }>>({
    queryKey: ['newsletterTypes'],
    queryFn: getNewsletterTypes,
  });
}
